import React from 'react';
import { Helmet } from 'react-helmet';

const GoogleAnalytics = () => (
    <Helmet>
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-GWD57NXYXS"></script>
        <script>
            {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-GWD57NXYXS');
      `}
        </script>
    </Helmet>
);

export default GoogleAnalytics;
